import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { StudentSchedule } from '../models/StudentSchedule';
import { StudentScheduleRequest } from '../models/StudentScheduleRequest';
import { OptionSet } from '../models/OptionSet';
import { CalendarService } from './calendar.service';
import { Schedule_ep } from '../models/Schedule_ep';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentScheduleService {


  public rout = "StudentSchedulesActions";

  request: StudentScheduleRequest;
  public ScheduleHoursList: Array<OptionSet> = new Array<OptionSet>();
  public selectedStudentSchedule: Schedule_ep = new Schedule_ep();

  constructor(private http: HttpClient,
    public dataService: DataService, private calendarSvc: CalendarService) {
    this.request = new StudentScheduleRequest();
  }
  SaveStudentSchedule() {
    this.request.Action = "SaveStudentSchedule";
    return this.dataService.setRequstData(this.rout, this.request);
  }

  GetModalOptions() {
    this.request.Action = "GetModalOptions";
    return this.dataService.setRequstData(this.rout, this.request);
  }
  GetStudentSchedule() {
    this.request.Action = "GetStudentSchedule";
    return this.dataService.setRequstData(this.rout, this.request);
  }
}
